import { PageHeader, SectionCard } from "@/components/ui-bits";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader title="Settings" subtitle="Account & platform configuration." />
      <div className="grid md:grid-cols-2 gap-6">
        <SectionCard title="Profile">
          <div className="space-y-3 text-sm">
            <Row label="Name" value={user?.name} />
            <Row label="Email" value={user?.email} />
            <Row label="Role" value={user?.role} />
            <Row label="Joined" value={user?.created_at?.slice(0,10)} />
          </div>
        </SectionCard>
        <SectionCard title="Platform">
          <div className="space-y-3 text-sm">
            <Row label="Version" value="2026.02 · v1.0" />
            <Row label="Auth" value="JWT (httpOnly cookies)" />
            <Row label="Storage" value="MongoDB" />
            <Row label="Certificates" value="ReportLab PDF" />
          </div>
        </SectionCard>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between border-b border-slate-100 pb-2">
      <span className="text-slate-500">{label}</span>
      <span className="text-slate-900 font-medium">{value || "—"}</span>
    </div>
  );
}
